import { useEffect } from "react";
import { Box, HStack, VStack } from "../../components/utils";
import BCHeader from "../../shared/BCHeader";
import AddTemplateSplit from "./AddTemplateSplit";
import { useQuickConversionTransactionStore } from "../../store/useQuickTransactionStore";
import { useAuthStore } from "../../store";
import { useGetOnGoingTransaction } from "../../queries/transactionRound";
import TransactionPreviewPage from "./TransactionPreviewPage";
import QuickAddConversion from "./QuickAddConversion";

function TransactionConversionTemplate() {
  const { state: template, setState: setTemplate } =
    useQuickConversionTransactionStore();
  const stepNo = template.stepNo;
  const companyId = useAuthStore.getState().companyId || "";
  const { refetch, data: onGoingTransaction } =
    useGetOnGoingTransaction(companyId);
  useEffect(() => {
    refetch();
  }, []);
  useEffect(() => {
    if (onGoingTransaction) setTemplate(onGoingTransaction);
    else {
      setTemplate({ stepNo: 1, transactionType: "conversion", companyId });
    }
  }, [onGoingTransaction]);

  return (
    <div className="min-h-full">
      <BCHeader
        className="items-baseline mb-2"
        bcTitle="Transaction Dashboard"
        bcSubTitle="Add Conversion"
      />
      {template.stepNo !== 2 ? <QuickAddConversion /> : null}
      {template.stepNo === 2 ? <TransactionPreviewPage /> : null}
    </div>
  );
}

export default TransactionConversionTemplate;
